import React, { PropsWithChildren } from "react";
import { APIProvider } from "@vis.gl/react-google-maps";
import { useSelector } from "react-redux";
import LoadingIndicator from "./components/LoadingIndicator";
import { makeSelectLanguage } from "./containers/App/selectors";
import type { SupportedLanguages } from "./viewModels/Settings/TranslationModel";

const googleMapsLanguageByAppLanguage: Record<SupportedLanguages, string> = {
  ru: "ru",
  en: "en",
  zh: "zh-CN",
};

const GoogleMapsProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const language = useSelector(makeSelectLanguage());
  const [initialLanguage, setInitialLanguage] = React.useState<SupportedLanguages | undefined>(language);

  React.useEffect(() => {
    if (!initialLanguage && language) {
      setInitialLanguage(language);
    }
  }, [initialLanguage, language]);

  if (!initialLanguage) {
    return <LoadingIndicator fullPage />;
  }

  return (
    <APIProvider apiKey={import.meta.env.VITE_GOOGLE_API_KEY as string} language={googleMapsLanguageByAppLanguage[initialLanguage]}>
      {children}
    </APIProvider>
  );
};

export default GoogleMapsProvider;
